import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file for VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY');
}

// Validate URL format
if (!supabaseUrl?.startsWith('https://') || !supabaseUrl?.includes('.supabase.co')) {
  console.error('❌ Invalid Supabase URL format. Expected format: https://[project-ref].supabase.co');
  console.error('Current URL:', supabaseUrl);
  throw new Error('Invalid VITE_SUPABASE_URL format. Please check your .env file.');
}

// Validate key format (should be a long string)
if (supabaseAnonKey?.length < 20) {
  console.error('❌ Invalid Supabase anon key format. Key appears too short.');
  throw new Error('Invalid VITE_SUPABASE_ANON_KEY format. Please check your .env file.');
}

// Create client with browser-compatible configuration
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
    storageKey: 'volaptic-auth-token'
  },
  global: {
    headers: {
      'X-Client-Info': 'volaptic-web'
    },
    fetch: fetch.bind(globalThis)
  },
  db: {
    schema: 'public'
  }
});
